export default "/assets/images/unit-slide1.b71f5c43133ace48.jpg";